/**
 * Site footer customization for kotsu2kabu.com.
 */

import React from 'react';
import { Container, List, Segment } from 'semantic-ui-react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Segment
      role="contentinfo"
      vertical
      padded
      inverted
      color="grey"
      textAlign="center"
      id="footer"
      aria-label="フッター"
      tabIndex="-1"
    >
      <Container>
        <List horizontal inverted className="k2k-footer">
          <div role="listitem" className="item">
            <span className="item">© {year} コツコツ株</span>
          </div>
          <div role="listitem" className="item">
            <a
              className="item"
              aria-label="投稿者・管理者ログイン"
              href="/login?return_url=/"
            >
              投稿者・管理者ログイン
            </a>
          </div>
        </List>
      </Container>
    </Segment>
  );
};

export default Footer;

